import { Icon, type IconProps } from '@iconik-io/uad';

import {
  type AssetTypeIconNameOptions,
  getAssetTypeIconName,
} from './get_asset_type_icon_name';

export type CardTitleIconProps = Omit<IconProps, 'name'> &
  AssetTypeIconNameOptions;

export const AssetTypeIcon = ({
  searchItem,
  fileType,
  proxies,
  formats,
  ...rest
}: CardTitleIconProps) => {
  const icon = getAssetTypeIconName({ searchItem, fileType, proxies, formats });

  if (!icon) {
    return null;
  }

  return <Icon {...rest} name={icon} />;
};
